export var STAFF_SELECTOR_PATH_DIVIDER = '###';
export var ZHB_UI_STAFF_SELECT_CLS_PREFIX = 'zhb-ui-staff-selector';